import {h, Fragment} from "preact"
import { 
    SelectSortV2 as SelectSort, 
    LayoutSelectorV2 as LayoutSelector,
    ButtonFiltersV2 as ButtonFilters
} from "../elements"
import { useCustomConfig } from "../../hooks/useCustomConfig"

export default function Toolbar() {

    const { customConfig } = useCustomConfig()
    const isSticky = customConfig.toolbar?.sticky || false

    return (
        <div className={`page-top-wrap scheme ${isSticky && 'sticky sticky-below-header ease-animation'}`}>
            <div className="toolbar">
                <div className="flex align-items-center justify-content-between">
                    <div class="flex align-items-stretch">
                        <ButtonFilters />
                        <SelectSort />
                    </div>
                    <div>{customConfig.grid.showLayoutButtons && <LayoutSelector />}</div>
                </div>
            </div>
        </div>
    )
}